
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sbsplay",
      function () {
        return require("private-next-pages/sbsplay/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sbsplay"])
      });
    }
  